import { selector, selectorFamily } from 'recoil'
import { get } from '../http/restservice'
import env from '../env/env'

const UserPlansAdmin = selector({
  key: 'UserPlansAdmin',
  get: async () => {
    const url = `${env.API_URL}adminservice/api/actionPlan/getPlans`
    const response = await get(url)

    if (response.isError) {
      return []
    }
    return response
  },
})

const UserBasketsAdmin = selector({
  key: 'UserPlansAdmin',
  get: async () => {
    const url = `${env.API_URL}adminservice/api/actionPlan/getUserMFBaskets`
    const response = await get(url)

    if (response.isError) {
      return []
    }
    return response
  },
})

const MFUserSubSeqBaskets = selectorFamily({
  key: 'MFUserSubSeqPlans',
  get: (clientCode) => async () => {
    const url = `${env.API_URL}adminservice/api/actionPlan/fetchSubsequentOneTimeOrder?clientCode=${clientCode}`
    const response = await get(url)

    if (response.isError) {
      return []
    }
    return response
  },
})

const MFSIPs = selectorFamily({
  key: 'MFSIPs',
  get: (clientCode) => async () => {
    console.log('🚀 ~ get: ~ clientCode:', clientCode)
    const url = `${env.API_URL}adminservice/api/actionPlan/activeSIPs?clientCode=${clientCode}`
    const response = await get(url)
    console.log('🚀 ~ get: ~ url:', url)

    if (response.isError) {
      return []
    }
    return response
  },
})

export { UserPlansAdmin, UserBasketsAdmin, MFUserSubSeqBaskets, MFSIPs }
